import axios from "axios";
import { UserExternalConnectionStatusRetrieveInterface } from "../../../middleware/interfaces/user/user-external-connection-status-interface";

export const UserExternalConnectionStatusRetrieve = {
  Retrieve: async (email: string) => {
    let serverResponse;
    const statusRetrieveData: UserExternalConnectionStatusRetrieveInterface = {
      email: email,
      type: "UserExternalConnectionStatusRetrieveInterface",
    };
    const url = "./php/user/user-external-connection-status-retriever-proxy.php";
    await axios
      .post(url, statusRetrieveData)
      .then((response) => {
        serverResponse = response.data;
      })
      .catch((error) => {
        serverResponse = {
          status: "error",
          header: "error",
          message: error.message,
        };
      });

    return serverResponse;
  },
};
